import { render, staticRenderFns } from "./ProspectsTable.vue?vue&type=template&id=35452fe0&scoped=true&"
import script from "./ProspectsTable.vue?vue&type=script&lang=ts&"
export * from "./ProspectsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectsTable.vue?vue&type=style&index=0&id=35452fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35452fe0",
  null
  
)

export default component.exports